// extracted by mini-css-extract-plugin
export default {"container":"xLcIU1","mobile":"lhRDtn"};